import { forwardRef } from "react";
import type { InputHTMLAttributes } from "react";
import { cn } from "@/lib/utils";

export type RadioProps = Omit<InputHTMLAttributes<HTMLInputElement>, "type">;

const radioClassName =
  "h-4 w-4 shrink-0 border-surface-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2 aria-invalid:border-error-500 aria-invalid:ring-error-500";

const Radio = forwardRef<HTMLInputElement, RadioProps>(
  ({ className, ...props }, ref) => (
    <input
      ref={ref}
      type="radio"
      className={cn(radioClassName, className)}
      {...props}
    />
  ),
);

Radio.displayName = "Radio";

export { Radio, radioClassName };
